import { Component, type ReactNode } from 'react'

/**
 * Crash boundary. Renders outside the app shell, so it uses the semantic
 * `.primary-button` class rather than the React Button primitive.
 *
 * Deliberately logs nothing anywhere: this app has no analytics and no error
 * reporting, because a survey response could end up in a breadcrumb or a stack
 * frame. A crash costs us the diagnostic, which is the correct trade here.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
	state = { failed: false }

	static getDerivedStateFromError() {
		return { failed: true }
	}

	render() {
		if (!this.state.failed) return this.props.children
		return (
			<main style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', padding: 24 }}>
				<div className="content-column text-center">
					<h1 className="section-title">Something went wrong</h1>
					<p className="body-copy">That is on us. Your answers so far are saved.</p>
					<button className="primary-button" onClick={() => window.location.reload()}>
						Try again
					</button>
				</div>
			</main>
		)
	}
}
